var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPublished(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 29,
    viewBox: "0 0 41 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_110_38910)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.1187 21.0428C40.1187 24.9309 36.8771 28.0949 32.9882 28.0949H7.13047C3.24162 28.0949 0 24.9309 0 21.0428C0 17.5544 2.62417 14.6489 5.95669 14.0879C5.95512 14.0557 5.95512 14.0228 5.95512 13.9907C5.95512 8.80584 10.1731 4.58789 15.3579 4.58789C16.0726 4.58789 16.7731 4.66781 17.4477 4.82061C16.9047 6.05473 16.603 7.41892 16.603 8.85364C16.603 14.3927 21.0937 18.8833 26.6327 18.8833C30.1642 18.8833 33.2695 17.0576 35.0568 14.2987C37.9529 15.1849 40.1187 17.8725 40.1187 21.0428Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7894 17.3952C31.593 17.3952 35.487 13.5012 35.487 8.69761C35.487 3.89405 31.593 0 26.7894 0C21.9858 0 18.0918 3.89405 18.0918 8.69761C18.0918 13.5012 21.9858 17.3952 26.7894 17.3952Z",
    fill: "#1FDB38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7002 7.92768L25.2535 12.4818L32.8243 4.91016",
    stroke: "white",
    strokeWidth: 2.27235,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_110_38910"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.1187,
    height: 28.0956,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublished);
export default __webpack_public_path__ + "static/media/Published.ede8e19c58e14d7adf9dcd0f8fee9215.svg";
export { ForwardRef as ReactComponent };